import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]

  async load(event) {
    const accountId = event.target.value
    const select = this.selectTarget

    if (!accountId) {
      select.innerHTML = '<option value="">Select account first...</option>'
      return
    }

    select.innerHTML = '<option value="">Loading...</option>'

    const response = await fetch(`/admin/connections?account_id=${accountId}`, {
      headers: { "Accept": "application/json" }
    })
    const connections = await response.json()

    if (connections.length === 0) {
      select.innerHTML = '<option value="">No connections found</option>'
      return
    }

    select.innerHTML = connections.map(c =>
      `<option value="${c.id}">${c.label}</option>`
    ).join("")
  }
}
